module.exports = __webpack_public_path__ + "media/bootstrap-icons/cup-straw-69149d06.svg";